/* Learn capture (2026-09-16): subscribes the reader to the Klaviyo "Learn"
   list from the end-of-lesson card and reports the lead. Klaviyo's client
   subscriptions API is called directly (no page reload, no customer form);
   on success we publish sbmd_learn_lead through Shopify's analytics bus,
   where the admin custom pixel forwards it to GA4 (generate_lead) and to
   Meta (Lead) — see docs/LEARN-CAPTURE.md. A localStorage flag hides the
   card once a reader has joined, on every article. */
(function () {
  'use strict';
  var KEY = 'sbmd-learn-lead-v1';
  var card = document.querySelector('[data-lesson-capture]');
  if (!card) return;

  var joined = false;
  try { joined = !!localStorage.getItem(KEY); } catch (e) {}
  if (joined) { card.hidden = true; return; }

  var form = card.querySelector('.lesson-capture-form');
  var email = card.querySelector('#lesson-capture-email');
  var errEl = card.querySelector('[data-lc-error]');
  var t0 = Date.now();

  function fail(msg) {
    errEl.textContent = msg;
    errEl.hidden = false;
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    errEl.hidden = true;
    if (form.website && form.website.value) return; /* honeypot */
    var value = (email.value || '').trim();
    if (!value || value.indexOf('@') < 1) {
      fail('That email does not look complete. One more try?');
      return;
    }
    var btn = card.querySelector('.lesson-capture-submit');
    btn.disabled = true;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Learn lesson capture',
          profile: { data: { type: 'profile', attributes: {
            email: value,
            properties: { 'Learn source article': card.dataset.article || '' }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: card.dataset.list } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(card.dataset.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('subscribe ' + res.status);
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      card.querySelector('[data-lc-form-state]').hidden = true;
      card.querySelector('[data-lc-success]').hidden = false;
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('sbmd_learn_lead', {
            article: card.dataset.article || '',
            ms: Date.now() - t0
          });
        }
      } catch (e) {}
    }).catch(function () {
      btn.disabled = false;
      fail('Something interrupted the signup. Please try once more.');
    });
  });
})();
